module.exports = __webpack_public_path__ + "static/media/tree with three lives.5a6d1cdc.png";